package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ObjectKinds
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ShapeEnum
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.pages.components.top_toolbar.component.CarouselButton
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.objects.Furniture
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.objects.Indicators
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.objects.InteriorDecoration
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.list.RestaurantProject
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project_content.RestaurantProjectContent
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.objects.RestaurantTable
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.objects.Structure
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState

@Composable
fun RestaurantManager(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
){
    LaunchedEffect(Unit){
        event(OptionsEvent.GetRestaurantProjects)
        event(OptionsEvent.InitFirstPageInRestaurantDesign)
    }

    if (windowSizeMode== WindowSizeModeEnum.TABLET){
        PageSweeper(event, state)
    }

    Row(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth()
            .borderSetting()
            .borderRadius(Dimen.semiLargeRadius)
            .padding(
                leftRight = Dimen.extraLargePadding,
                bottom = Dimen.extraLargePadding,
                top = Dimen.largePadding
            )
    )
    {

        if (state.restaurantProjects!=null){
            if (state.firstPageActive){

                Column(
                    modifier = Modifier
                        .fillMaxHeight()
                        .width(Dimen.restaurantProjectWidth),
                    horizontalAlignment = Alignment.CenterHorizontally
                )
                {

                    RestaurantProject(
                        restaurantProjects=state.restaurantProjects,
                        selectedRestaurantProject=state.selectedRestaurantProject,
                        selectedRoom=state.selectedRestaurantRoom,
                        windowSizeMode = windowSizeMode,
                        fillMaxWidth = false,
                        searchValue = "",
                        onSearchValueChange = {
                            event(OptionsEvent.OnSearchInRestaurantProject(it))
                        },
                        onProjectClick = {
                            event(OptionsEvent.OnRestaurantProjectClick(it))
                        },
                        onRoomClick = {room,restaurantProject->
                            event(OptionsEvent.OnRestaurantRoomClick(
                                room = room,
                                restaurantProject=restaurantProject,
                                switchThePageForMobileAndTabletMode =windowSizeMode!= WindowSizeModeEnum.Desktop
                            ))
                        },
                        onFloorClick = {restaurantProject ->
                            event(OptionsEvent.OnRestaurantFloorClick(restaurantProject))
                        }
                    )

                    if (state.selectedRestaurantRoom!=null){

                        RestaurantTable(
                            windowSizeMode=windowSizeMode,
                            selectedTableColor=state.selectedRestaurantDesignTableColor?:
                                Theme.Transparent.hex,
                            selectedFurniture=state.selectedFurniture,
                            onRestaurantTableColorClick = {
                                event(OptionsEvent.SetRestaurantTableColorDialogStatus(true))
                            },
                            onCreateTableClick = { shape: ShapeEnum, number:String->
                                event(OptionsEvent.CreateFurniture(
                                    shape = shape,
                                    number=number,
                                    componentColor =state.selectedRestaurantDesignTableColor,
                                    objectKind = ObjectKinds.TABLE_RECTANGLE,
                                ))
                            },
                            onUpdateTable = {number:String->
                                event(OptionsEvent.UpdateFurniture(
                                    id=state.selectedFurniture?.id?:"",
                                    componentColor = state.selectedRestaurantDesignTableColor,
                                    caption = number,
                                ))
                            }
                        )

                        Structure(
                            onSubmitClick={objectKind:ObjectKinds->
                                event(OptionsEvent.CreateFurniture(
                                    shape = ShapeEnum.RECTANGLE,
                                    objectKind = objectKind,
                                ))
                            }
                        )

                        Furniture(
                            onSubmitClick={objectKind:ObjectKinds->
                                event(OptionsEvent.CreateFurniture(
                                    shape = ShapeEnum.RECTANGLE,
                                    objectKind = objectKind,
                                ))
                            }
                        )

                        InteriorDecoration(
                            onSubmitClick = {
                                if (it.shape!=null){
                                    event(OptionsEvent.CreateFurniture(
                                        shape = it.shape,
                                        objectKind = it,
                                    ))
                                }

                            },
                        )

                        Indicators(
                            onSubmitClick = {
                                if (it.shape!=null){
                                    event(OptionsEvent.CreateFurniture(
                                        shape = it.shape,
                                        objectKind = it,
                                    ))
                                }
                            }
                        )
                    }


                }
            }
            if (!state.firstPageActive || windowSizeMode== WindowSizeModeEnum.Desktop){

                if (state.selectedRestaurantProject!=null){

                    RestaurantProjectContent(
                        windowSizeMode=windowSizeMode,
                        selectedRestaurantProject=state.selectedRestaurantProject,
                        selectedRoom = state.selectedRestaurantRoom,
                        onMoveFurniture = {id:String,offsetX:Int,offsetY:Int
                                           ,rotationDeg:Int,width:Int,height:Int->
                            event(
                                OptionsEvent.UpdateFurniture(
                                    id=id,
                                    height =height,
                                    positionLeft =offsetX ,
                                    positionTop =offsetY,
                                    rotationDeg=rotationDeg,
                                    width=width
                                )
                            )
                        },
                        onTransformFurniture = {id:String,offsetX:Int,offsetY:Int
                                                ,rotationDeg:Int,width:Int,height:Int,
                                                objectKind:String?,
                                                ->
                            event(
                                OptionsEvent.TransformFurniture(
                                    id=id,
                                    height =height,
                                    positionLeft =offsetX ,
                                    positionTop =offsetY,
                                    rotationDeg=rotationDeg,
                                    width=width,
                                    objectKind=objectKind,
                                )
                            )
                        },
                        showRestaurantFloorDialog = {
                            event(
                                OptionsEvent.SetAddRestaurantFloorDialogStatus(true)
                            )
                        },
                        showDeleteFloorDialog = {
                            event(OptionsEvent.SetDeleteFloorDialogStatus(
                                status = true,
                                floorId=it,
                            ))
                        },
                        showDeleteRoomDialog = {
                            event(OptionsEvent.SetDeleteRoomDialogStatus(
                                status = true,
                                roomId = it
                            ))
                        },
                        showEditFloorDialog = {floorId:String?,floorNumber:Int?->
                            event(
                                OptionsEvent.SetEditRestaurantFloorDialogStatus(
                                    status = true,
                                    floorNumber=floorNumber,
                                    floorId=floorId,
                                )
                            )
                        },
                        createRoom = {caption:String,floorId:String,projectId:String->
                            event(
                                OptionsEvent.CreateRestaurantRoom(
                                    caption=caption,
                                    floorId=floorId,
                                    projectId=projectId,
                                )
                            )
                        },
                        updateRoom = {caption:String,roomId:String->
                            event(
                                OptionsEvent.UpdateRestaurantRoom(
                                    caption=caption,
                                    roomId=roomId,
                                )
                            )
                        },
                        updateProject={caption:String->
                            event(
                                OptionsEvent.UpdateRestaurantProject(
                                    caption=caption
                                )
                            )
                        },
                        onSelectNewRoom = {
                            event(
                                OptionsEvent.OnRestaurantRoomClick(
                                    room = it,
                                    restaurantProject = state.selectedRestaurantProject,
                                    switchThePageForMobileAndTabletMode = false
                                )
                            )
                        },
                        onDeleteFurniture = {
                            event(OptionsEvent.DeleteFurniture(id = it))
                        },
                        onCopyFurniture = {
                            event(
                                OptionsEvent.CopyFurniture(it)
                            )
                        },
                        onFurnitureFocus = {
                            event(OptionsEvent.OnFurnitureFocus(it))
                        }

                    )
                }
            }

        }





    }


}



@Composable
private fun PageSweeper(
    event: (OptionsEvent) -> Unit,
    state: OptionsState
) {
    Box(
        modifier = Modifier.fillMaxSize()
            .padding(Dimen.normalPadding)
    )
    {
        CarouselButton(
            modifier = Modifier
                .align(Alignment.TopEnd)
                .zIndex(Constants.ZIndex.mediumZIndex),
            onScrollButtonClick = {
                event(OptionsEvent.SweepRestaurantPagesForTablet(!state.firstPageActive))
            }
        )

    }
}


